"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var facet_utils_1 = require("../facet_utils");
var collapsing_facet_1 = require("./collapsing_facet");
var select_facet_option_1 = require("./select_facet_option");
var NestedSelectFacet = /** @class */ (function (_super) {
    tslib_1.__extends(NestedSelectFacet, _super);
    function NestedSelectFacet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NestedSelectFacet.prototype.renderChildrenFor = function (option) {
        var _this = this;
        if (!option.subFilter || !option.subFilter.options) {
            return null;
        }
        var links = option.subFilter.options.map(function (option, idx) { return (React.createElement(select_facet_option_1.default, { key: idx, option: option }, facet_utils_1.isChildSelected(option, true) && _this.renderChildrenFor(option))); });
        return (React.createElement(collapsing_facet_1.default, { count: links.length, countThreshold: 6 },
            React.createElement("ul", { className: "facet__options" }, links)));
    };
    NestedSelectFacet.prototype.renderRootLinks = function () {
        var _this = this;
        var nothingSelected = !facet_utils_1.isSomethingSelected(this.props.filter);
        return this.props.filter.options.map(function (option, idx) {
            if (option.selected || facet_utils_1.isChildSelected(option)) {
                return (React.createElement(select_facet_option_1.default, { key: idx, option: option, childActive: true }, _this.renderChildrenFor(option)));
            }
            if (nothingSelected || option.all) {
                return React.createElement(select_facet_option_1.default, { key: idx, option: option, childActive: option.all });
            }
        });
    };
    NestedSelectFacet.prototype.render = function () {
        if (this.props.filter.options.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "facet" },
            React.createElement("div", { className: "facet__heading" }, this.props.filter.name),
            React.createElement("ul", { className: "facet__options" }, this.renderRootLinks())));
    };
    return NestedSelectFacet;
}(React.Component));
exports.default = NestedSelectFacet;
//# sourceMappingURL=nested_select_facet.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/nested_select_facet.js
// module id = 3Faq
// module chunks = 0 1 2 3 4 9 10 14 20